// WF一覧CSV出力情報
export class ReceptionDetailCsvFilePrint {
    downloadUrl: string;
    overLimitMessage: string;
}
